import { createContext } from 'react';
import { StreamChat } from 'stream-chat';

import type { LiveChatChannelTrainingSession, LiveChatQuery } from 'src/components/v2/LiveChat/liveChat.types';

export type LiveChatContextValue = {
  providerUserId: string;
  token: NonNullable<LiveChatQuery['liveChat']['token']>;
  initialUserSetting: LiveChatQuery['liveChat']['userSetting'];
  channelTrainingSessions: LiveChatChannelTrainingSession[];
  client: StreamChat;
};

export const liveChatContext = createContext<undefined | LiveChatContextValue>(undefined);
